import React from 'react';
import { Phone, Mail, MapPin, Youtube, Linkedin } from 'lucide-react';
import { academyInfo } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About Section */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/images/logo.png"
                alt="Stocks Vision Academy Logo"
                className="h-16 w-auto brightness-0 invert" />

              <h3 className="text-white text-xl font-bold">{academyInfo.name}</h3>
            </div>
            <p className="text-sm leading-relaxed mb-4">
              Professional stock market training institute in Bhopal. We focus on practical, execution-oriented learning with strong emphasis on risk management.
            </p>
            <p className="text-sm text-gray-400">
              <span className="text-green-400 font-semibold">Location:</span> {academyInfo.city}, {academyInfo.state}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#courses" className="hover:text-green-400 transition-colors">Our Courses</a></li>
              <li><a href="#why-choose" className="hover:text-green-400 transition-colors">Why Choose Us</a></li>
              <li><a href="#testimonials" className="hover:text-green-400 transition-colors">Student Reviews</a></li>
              <li><a href="#location" className="hover:text-green-400 transition-colors">Location</a></li>
              <li><a href="#enquiry" className="hover:text-green-400 transition-colors">Enquire Now</a></li>
            </ul>
          </div>

          {/* Courses */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Our Courses</h4>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-green-400 transition-colors cursor-pointer">Advanced Technical Analysis</li>
              <li className="hover:text-green-400 transition-colors cursor-pointer">Options Trading Mastery</li>
              <li className="hover:text-green-400 transition-colors cursor-pointer"></li>
              <li className="hover:text-green-400 transition-colors cursor-pointer"></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="h-4 w-4 text-green-400 flex-shrink-0 mt-0.5" />
                <a href={`tel:${academyInfo.phone}`} className="hover:text-green-400 transition-colors">
                  {academyInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="h-4 w-4 text-green-400 flex-shrink-0 mt-0.5" />
                <span>academy@stocksvision.in</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-green-400 flex-shrink-0 mt-0.5" />
                <span className="leading-relaxed">
                  {academyInfo.address}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Media & Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Social Media */}
            <div className="flex gap-4">
              <a 
                href="https://www.youtube.com/@StocksVisionAcademy" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-600 transition-colors"
                aria-label="Visit our YouTube channel"
              >
                <Youtube className="h-5 w-5" />
              </a>
              <a 
                href="https://www.linkedin.com/in/deepak-singhai-9b0474382" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-600 transition-colors"
                aria-label="Connect on LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a 
                href="https://share.google/WJimSzFpGgqedo5s2" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-600 transition-colors"
                aria-label="View our Google Business Profile"
              >
                <MapPin className="h-5 w-5" />
              </a>
            </div>

            {/* Copyright */}
            <div className="text-center md:text-right">
              <p className="text-sm text-gray-400">
                © {new Date().getFullYear()} {academyInfo.name}. All rights reserved.
              </p>
              <p className="text-xs text-gray-500 mt-1">
                <span className="font-semibold">Disclaimer:</span> Trading involves risk. No profit guarantees.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;